<div class="resume">
    <h3 class="content-title">THERMODYNAMICS</h3>

    <ul>
        <li>"On the Thermodynamics of Upconversion and Fluorescence of Light", J. Appl. Phys. 66, 5685 (1989); DOI:10.1063/1.343636</li>
        <li>"Upconversion and the Fluorescence of Laser Light", Proc. of Int. Conf. on Lasers '90, SOQE, San Diego, CA, Dec. 1990, pp 399-406.</li>
        <li>"Modification to Thermal Emissions by Clusters on Their Own Metallic Surface", J. Vac. Sci. Technol. A, 8(1), 127 (1990).</li>
        <li>J. R. Andrews and O. Biblarz, "Temperature dependence of Gas Properties in Polynomial Form", NPS67-81-001, January 1981. (Available from DTIC, Accession Number: ADA096388).</li>
        <li>"Time, Temperature and Thermodynamics", Unpublished.</li>


    </ul>
    
  

  </div>



